$(document).on('ready', function () {
    $('.scroll-to__bottom a').on('click', function (e) {
        const parentSection = $(this).closest('.shopify-section');
        const scrollSection = parentSection.next();
        $('html, body').animate({
            scrollTop: scrollSection.offset().top
        }, 1000);
    })
    if($('.js-thumbnails-slider')) {
        $('.js-thumbnails-slider').slick({
            vertical: true,
            verticalSwiping: true,
            slidesToShow: 5,
            slidesToScroll: 1,
            infinite: false,
            focusOnSelect: true,
        })

        $('.js-thumbnails-slider .slick-slide').click(function(e) {
            $('.js-thumbnails-slider .slick-slide').removeClass('slick-active').removeClass('slick-current').removeClass('active');
            $(this).addClass('slick-active').addClass('slick-current').addClass('active')
        })
        $('.js-thumbnails-slider .slick-next').click(function(e) {
            let next = $('.js-thumbnails-slider .slick-current').next();
            if(next[0] !== undefined) {
                console.log(next[0]);
                $('.js-thumbnails-slider .slick-slide').removeClass('active')
                next.addClass('active')
                $('.js-thumbnails-slider .active a')[0].click();
            }
        })
        $('.js-thumbnails-slider .slick-prev').click(function(e) {
            let prev = $('.js-thumbnails-slider .slick-current').prev();
            if(prev[0] !== undefined){
                console.log(prev[0]);

                $('.js-thumbnails-slider .slick-slide').removeClass('active')
                prev.addClass('active')
                $('.js-thumbnails-slider .active a')[0].click();
            }
        })
    }
    $('.baby__logo-icon').css('opacity', '1');
    $('.baby-instagram-section  #insta-feed').on('DOMSubtreeModified',function (){
        let slides= $(this).find('.slide-page')
        console.log(slides)
       if(slides.length > 0){
             slides.each(function (index){
               let position = index+1;
               if (window.matchMedia("(max-width: 768px) and (min-width: 475px)").matches) {
                   $(this).attr("data-slide-page", Math.ceil(position/2))
               } else if (window.matchMedia("(max-width: 475px)").matches){
                   $(this).attr("data-slide-page", position)
               }else {
                   $(this).attr("data-slide-page", Math.ceil(position/4))
               }

           })
       }
    })

    if ( $('#ProductSection').length || $('.product-miniature').length ) {
        //SET THIS TO TRUE AFTER TESTING
        let sizeEnable = true;

        if (/DEVMODE/.test(window.location.href)) {
            sizeEnable = true
        }
        if (sizeEnable && $('.badge--size-tag').length) {
            const badge = $('.badge--size-tag');
            let size

            badge.each(function () {
              const badgeItem = $(this)
              if (/us.le-olive/.test(window.location.href) || /uk.le-olive/.test(window.location.href) ) {
                size = badgeItem.attr('data-us');
            } else {
                 size = badgeItem.attr('data-eu');
            }

            if ( size.length ) {
                badgeItem.find('span').html(size);
                badgeItem.removeClass('hidden');
            }
            })
            


        }
    }

    if ( $('.hidden__grid-item').length ) {
        $('.hidden__grid-item').remove();
    }
})
$( window ).resize(function (){
    let instagrabBlock = $('.baby-instagram-section  #insta-feed')
    let slides= instagrabBlock.find('.slide-page')
    if(slides.length > 0){
        slides.each(function (index){
            console.log("asdasd")
            let position = index+1;
            if (window.matchMedia("(max-width: 768px) and (min-width: 475px)").matches) {
                $(this).attr("data-slide-page", Math.ceil(position/2))
            } else if (window.matchMedia("(max-width: 475px)").matches){
                $(this).attr("data-slide-page", position)
            }else {
                $(this).attr("data-slide-page", Math.ceil(position/4))
            }
        })
        instagrabBlock.find('.slide-page').css('display','none');
        instagrabBlock.find('.slide-page[data-slide-page="1"]').css('display','initial');
    }
})
$(document).on('DOMSubtreeModified','.product-single__price',function (){
    const curency = $('body').attr('data-currency-symbol')
    const price = parseFloat($(this)[0].innerHTML.replace(curency, '').replace(',','.'));
    const originalPrice = parseFloat($(this).closest('.product-single__prices').attr('data-original-price').replace(',','.'));
    const comparePrice = parseFloat($(this).closest('.product-single__prices').find('.product-single__price--compare').attr('content'));
    const comparePriceBlock = $(this).closest('.product-single__prices').find('.product-single__price--compare');
    if(comparePriceBlock.length !=0){
        if(price > originalPrice && price != NaN){
            let newCompare=comparePrice+(price-originalPrice)
            comparePriceBlock[0].innerHTML= curency+newCompare.toFixed(2)
        }else if(price == originalPrice && price != NaN){
            comparePriceBlock[0].innerHTML= curency+comparePrice;
        }
    }

})


$(document).ready(function($) {
    $(window).load(function() {
        if (!window.localStorage.getItem('preloaderIsShown')) {
            $('#preloader').addClass('show');
            $('#preloader').css('z-index', '999999');
            $('body').css('opacity', '1');
            setTimeout(function() {
                $('#preloader').removeClass('show');
                $('#preloader').css('opacity', '0');
                $('#preloader').css('z-index', '-1');
                window.localStorage.setItem('preloaderIsShown', true);
            }, 2000);
        } else {
            $('#preloader').removeClass('show');
            $('#preloader').css('opacity', '0');
            $('#preloader').css('z-index', '-1');
            $('body').css('transition', '.2s');
            $('body').css('opacity', '1');
        }
    });




});
$('.header-mobile-menu-list-item.collection-item.has-submenu .icon').on('click', function (){
    $(this).closest('.header-mobile-menu-list-item').addClass('open')
});
$('.header-mobile-menu-list-item .mobile-menu-submenu-header').on('click', function (){
    $(this).closest('.header-mobile-menu-list-item').removeClass('open')
});
$('.header-mobile-menu-list-item.has-accordion .icon').on('click', function (){
    $(this).closest('.header-mobile-menu-list-item').toggleClass('open');
    $(this).closest('.header-mobile-menu-list-item').find('.header-mobile-menu-list-item-accordion').slideToggle();
});
$('.header-mobile-menu-close').on('click', function (){
    $('#header-mobile-menu').removeClass('open')
});
$('.js-language-selector a').on('click', function (e){
    e.preventDefault();
    updateLocalization($(this).attr('href'));
});
function updateLocalization(language) {
    const formId = crypto.randomUUID();
    const formHtml = `
        <form id="${formId}" action="/localization" method="POST" hidden>
          <input name="_method" value="PUT">
          <input name="language_code" value="${language}">
          <input name="return_to" value="${location.pathname}">
        </form>
      `;
    document.body.insertAdjacentHTML("beforeend", formHtml);
    document.getElementById(formId).submit();
}




// cart 
